<div class="defense-dialog ups-dialog">
    <div class="dialog-header">
        <div class="header">
            <h1 *ngIf="count == 1">What’s new with Parcel Pro</h1>
            <h2 *ngIf="count == 2">See how DeliveryDefense<sup class="tm">TM</sup> Address Confidence works</h2>
            <h1 *ngIf="count == 3">Parcel Pro Platform Integration</h1>
            <div class="separator"></div>
        </div>
        <!-- close button UI changed as per the observation -->
        <!-- <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button> -->
        <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <div class="content-panel">
            <ng-container *ngIf="count == 1" [ngTemplateOutlet]="popup1"></ng-container>
            <ng-container *ngIf="count == 2" [ngTemplateOutlet]="popup2"></ng-container>
            <ng-container *ngIf="count == 3" [ngTemplateOutlet]="popup3"></ng-container>
        </div>
        <div class="action-panel">
            <div>
                <img src="../../../assets/icons/chevron_left (1).svg" alt="chevron_left" (click)="previousButton()" class="chevron_left-icon">
            </div>

            <div class="indicator-panel">
                <div *ngFor="let slideNumber of [1, 2, 3]" class="action-icons">
                    <img *ngIf="count !== slideNumber" [ngClass]="{'margin-top-3px': count !== slideNumber}" [id]="'slide' + slideNumber" (click)="actionBtn($event)" src="../../../assets/icons/Ellipse 14.svg" alt="Ellipse14">
                    <img *ngIf="count === slideNumber" src="../../../assets/icons/Ellipse 13.svg" alt="Ellipse13" class="Ellipse13-icon">
                </div>
            </div>

            <div>
                <img src="../../../assets/icons/chevron_right (1).svg" alt="chevron_right" (click)="nextButton()" class="chevron_right-icon">
            </div>
        </div>
        <div class="action-btn">
            <button mat-flat-button (click)="signUp()" class="complementary-btn">{{buttonChange}}</button>
            <button mat-stroked-button (click)="faq()" class="learn-more-btn">Learn More</button>
        </div>
    </mat-dialog-content>

    <ng-template #popup1>
        <div id="section" class="row section">
            <div class="col-sm-6 sub-section">
                <div class="row icon-row">
                    <img src="../../../assets/icons/logo-dd-shipping-intelligence.svg" alt="frame" class="frame-icon">
                </div>
            </div>
            <div class="col-sm-6 sub-section">
                <div class="row description">
                    <h5> Delivery Intelligence for Better Shipping Decisions.</h5>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #popup2>
        <div id="section" class="section-block">
            <img src="../../../assets/images/Background Blur.png" alt="Background Blur" class="background-blur">

            <a target="_blank" href="https://www.youtube.com/watch?v=u_TQUvpOHrU">
                <img src="../../../assets/images/play_circle.svg" alt="play_circle" class="play-circle">
            </a>
        </div>
    </ng-template>
    <ng-template #popup3>
        <div class="dd-formula">
            <div class="sum">
                <div class="image-container">
                    <img src="../../../assets/icons/logo-dd-shipping-intelligence.svg" alt="DeliveryDefense">
                </div>
                <div class="operator-styling">+</div>
                <div class="image-container">
                    <img src="../../../assets/icons/UPS_Flat_Shield_2Color_RGB 1.svg" alt="UPS Access Point">
                    <p> Access Point <sup>®</sup> <br> Location</p>
                </div>
            </div>
            <div class="result">
                <div>
                    <p> Confidence & Convenience</p>
                </div>
            </div>
        </div>
    </ng-template>
</div>